"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _find = _interopRequireDefault(require("lodash/find"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _styles = require("./styles");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _StepsSwiperResizeListenerComponent; //lodash
//components
//styled-components
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
//constants
var EXTENDED_PORTRAIT_RATIO = 4 / 7;
var LANDSCAPE_RATIO = 8 / 3;
var PORTRAIT_RATIO = 2 / 3;
var StepsSwiperResizeListenerComponent = exports["default"] = (0, _mobxReact.observer)(_class = (_class2 = (_StepsSwiperResizeListenerComponent = /*#__PURE__*/function (_Component) {
  function StepsSwiperResizeListenerComponent(props) {
    var _this;
    _classCallCheck(this, StepsSwiperResizeListenerComponent);
    _this = _callSuper(this, StepsSwiperResizeListenerComponent, [props]);
    _initializerDefineProperty(_this, "width", _descriptor, _this);
    _initializerDefineProperty(_this, "height", _descriptor2, _this);
    _initializerDefineProperty(_this, "isResizing", _descriptor3, _this);
    _defineProperty(_this, "eventName", _this.props.eventName);
    // to keep it constant
    _defineProperty(_this, "wrapperRef", null);
    _initializerDefineProperty(_this, "handleWindowResize", _descriptor4, _this);
    _initializerDefineProperty(_this, "updateDimensions", _descriptor5, _this);
    _defineProperty(_this, "calculateLayout", function (_ref) {
      var width = _ref.width,
        height = _ref.height;
      var _this$props = _this.props,
        maxCardWidth = _this$props.maxCardWidth,
        minPortraitRatio = _this$props.minPortraitRatio,
        navigationArrowsHeight = _this$props.navigationArrowsHeight,
        onChange = _this$props.onChange;
      var _this$getResponsiveMa = _this.getResponsiveMargins(),
        cardHint = _this$getResponsiveMa.cardHint,
        cardSpacing = _this$getResponsiveMa.cardSpacing;
      var isPortrait = width / height < minPortraitRatio;
      var availableWidth = Math.min(width - 2 * (cardHint + cardSpacing), maxCardWidth);
      var availableHeight = height - navigationArrowsHeight;
      var _this2 = _this[isPortrait ? 'getPortraitSizes' : 'getLandscapeSizes'](availableWidth, availableHeight, cardSpacing),
        imageHeight = _this2.imageHeight,
        imageWidth = _this2.imageWidth,
        slideHeight = _this2.slideHeight,
        slideWidth = _this2.slideWidth;
      var extraVerticalSpace = (availableHeight - slideHeight) / 2;
      var orientation = isPortrait ? 'portrait' : 'landscape';
      var overlayHeight = availableHeight;
      var overlayWidth = (width - slideWidth) / 2;
      var containerHeight = availableHeight - extraVerticalSpace;
      var ratio = isPortrait ? PORTRAIT_RATIO : LANDSCAPE_RATIO;
      onChange({
        cardHint: cardHint,
        cardSpacing: cardSpacing,
        containerHeight: containerHeight,
        extraVerticalSpace: extraVerticalSpace,
        imageHeight: imageHeight,
        imageWidth: imageWidth,
        orientation: orientation,
        overlayHeight: overlayHeight,
        overlayWidth: overlayWidth,
        slideHeight: slideHeight,
        slideWidth: slideWidth,
        ratio: ratio
      });
    });
    _defineProperty(_this, "debounce", (0, _debounce["default"])(function (callback) {
      return callback();
    }, 250));
    _defineProperty(_this, "getLandscapeSizes", function (availableWidth, availableHeight, cardSpacing) {
      var cardWidth, cardHeight;
      if (availableHeight * LANDSCAPE_RATIO > availableWidth) {
        cardWidth = availableWidth;
        cardHeight = availableWidth / LANDSCAPE_RATIO;
      } else {
        cardWidth = availableHeight * LANDSCAPE_RATIO;
        cardHeight = availableHeight;
      }
      return {
        imageHeight: cardHeight,
        imageWidth: cardWidth / 2,
        slideHeight: cardHeight,
        slideWidth: cardWidth + cardSpacing
      };
    });
    _defineProperty(_this, "getPortraitSizes", function (availableWidth, availableHeight, cardSpacing) {
      var cardWidth, cardHeight;
      if (availableHeight * PORTRAIT_RATIO > availableWidth) {
        cardWidth = availableWidth;
        cardHeight = availableWidth / PORTRAIT_RATIO;
        if (cardHeight < availableHeight) {
          cardHeight = Math.min(cardWidth / EXTENDED_PORTRAIT_RATIO, availableHeight);
        }
      } else {
        cardWidth = availableHeight * PORTRAIT_RATIO;
        cardHeight = availableHeight;
      }
      return {
        imageHeight: cardWidth * 3 / 4,
        imageWidth: cardWidth,
        slideHeight: cardHeight,
        slideWidth: cardWidth + cardSpacing
      };
    });
    _defineProperty(_this, "getResponsiveMargins", function () {
      var _this$props2 = _this.props,
        defaultResponsiveMargin = _this$props2.defaultResponsiveMargin,
        responsiveMargins = _this$props2.responsiveMargins;
      return (0, _find["default"])(responsiveMargins, function (margins) {
        return margins.breakpoint > _this.width;
      }) || responsiveMargins[defaultResponsiveMargin];
    });
    _defineProperty(_this, "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(StepsSwiperResizeListenerComponent, _Component);
  return _createClass(StepsSwiperResizeListenerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener(this.eventName, this.handleWindowResize);
      this.updateDimensions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener(this.eventName, this.handleWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_styles.StepsSwiperResizeListener, {
        ref: this.setWrapperRef
      }, this.renderChildren());
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        minHeight = _this$props3.minHeight,
        minWidth = _this$props3.minWidth,
        shouldHideContentWhileResizing = _this$props3.shouldHideContentWhileResizing;
      if (this.isResizing && shouldHideContentWhileResizing) {
        return /*#__PURE__*/_react["default"].createElement(_styles.ResizingMessage, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "resize"
        }));
      }
      if (this.width < minWidth || this.height < minHeight) {
        return /*#__PURE__*/_react["default"].createElement(_styles.ResizingMessage, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "resize-problem"
        }));
      }
      return children;
    }
  }]);
}(_react.Component), _defineProperty(_StepsSwiperResizeListenerComponent, "defaultProps", {
  disabled: false,
  eventName: 'resize',
  minWidth: 200,
  navigationArrowsHeight: 0,
  shouldHideContentWhileResizing: true
}), _defineProperty(_StepsSwiperResizeListenerComponent, "propTypes", {
  defaultResponsiveMargin: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  // The custom "orientationchangeend" event requires and emulator to be
  // installed. Reference: clients/viewer-mobile/config/polyfills.js.
  eventName: _propTypes["default"].oneOf(['orientationchangeend', 'resize']),
  maxCardWidth: _propTypes["default"].number.isRequired,
  minHeight: _propTypes["default"].number.isRequired,
  minPortraitRatio: _propTypes["default"].number.isRequired,
  minWidth: _propTypes["default"].number,
  navigationArrowsHeight: _propTypes["default"].number,
  onChange: _propTypes["default"].func.isRequired,
  responsiveMargins: _propTypes["default"].objectOf(_propTypes["default"].shape({
    breakpoint: _propTypes["default"].number.isRequired,
    cardHint: _propTypes["default"].number.isRequired,
    cardSpacing: _propTypes["default"].number.isRequired
  })).isRequired,
  shouldHideContentWhileResizing: _propTypes["default"].bool
}), _StepsSwiperResizeListenerComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "width", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "height", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isResizing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "handleWindowResize", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      var disabled = _this3.props.disabled;
      if (disabled || !_this3.wrapperRef) {
        return;
      }
      var _this3$wrapperRef$get = _this3.wrapperRef.getBoundingClientRect(),
        width = _this3$wrapperRef$get.width,
        height = _this3$wrapperRef$get.height;
      var isFullScreenVideo = width === window.innerWidth;
      // First check if changed, otherwise fullscreen video's freak won't work
      if (!isFullScreenVideo && (_this3.width !== width || _this3.height !== height)) {
        _this3.isResizing = true;
        _this3.debounce(function () {
          _this3.updateDimensions();
        });
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "updateDimensions", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function () {
      if (!_this4.wrapperRef) {
        return;
      }
      var _this4$wrapperRef$get = _this4.wrapperRef.getBoundingClientRect(),
        width = _this4$wrapperRef$get.width,
        height = _this4$wrapperRef$get.height;
      _this4.width = width;
      _this4.height = height;
      _this4.isResizing = false;
      _this4.calculateLayout({
        width: width,
        height: height
      });
    };
  }
})), _class2)) || _class;
//# sourceMappingURL=index.js.map